import ContentHeader from './container';

export default ContentHeader;
